/**
 *
 * @param {number} aNumber
 * @param {number} bNumber
 * @returns {number}
 */
export default function (aNumber, bNumber, order) {
  return order === 'asc' ? aNumber - bNumber : bNumber - aNumber;
}
